// controlPage page strings. Keys are read as $t('controlPage.<key>').
// Report file names are data (also the download name) and stay as they are; the group
// chip is translated through groupLabel(), item.group still drives the download rules.
export default {
  en: {
    pageTitle: 'Control Page - FitFoodCS',
    title: 'Control Files',
    subtitle: 'Download planning and payment reports for a week.',
    selectWeek: 'Select Week',
    customerIdPh: 'customer id',
    col: {
      file: 'Report Name',
      group: 'Group',
    },
    group: {
      planning: 'Planning',
      payment: 'Payment',
      planningVsPayment: 'Planning vs Payment',
    },
  },
  vi: {
    pageTitle: 'Báo cáo - FitFoodCS',
    title: 'File báo cáo',
    subtitle: 'Tải các báo cáo planning và thanh toán theo tuần.',
    selectWeek: 'Chọn tuần',
    customerIdPh: 'mã khách hàng',
    col: {
      file: 'Tên báo cáo',
      group: 'Nhóm',
    },
    group: {
      planning: 'Planning',
      payment: 'Thanh toán',
      planningVsPayment: 'Planning - Thanh toán',
    },
  },
}
